import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {StyledUserOverviewRightPanel} from './StyledUserOverviewRightPanel';
import AddExpenseButton from '../../ExpensesPage/AddExpenseButton';
import CardDetails from '../../SubscriptionPage/tabComponents/Overview/CardDetails/CardDetails';
import ScaleFade from '../../../animations/ScaleFade';
import {cardTypesConstants} from '../../../../constants';
import {bankingActions} from '../../../../state/actions/banking.actions';

const UserOverviewRightPanel = ({
  card,
  onDeleteCard,
  ...rest
}) => {
  const [cardDetails, setCardDetails] = useState(null);

  const [t] = useTranslation(['main', 'subscriptions']);

  const dispatch = useDispatch();

  const cardId = useMemo(() => card?.card_id, [card]);

  useEffect(() => {
    if (card) {
      const cardId = card?.card_id;
      const ownerId = card?.owner?.id;
      if (!(cardId && ownerId)) return;

      dispatch(bankingActions.getUserCardDetails(
        ownerId,
        cardId,
        setCardDetails,
        () => setCardDetails(null)
      ));
    } else if (cardDetails) {
      setCardDetails(null);
    }
  }, [card?.card_id, card?.owner?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePauseSuccess = (data) => {
    setCardDetails({ ...cardDetails, status_code: data.lock_status });
  }

  return (
    <StyledUserOverviewRightPanel
      direction='vertical'
      size={48}
      {...rest}
    >
      <AddExpenseButton style={{ width: '100%' }}>
        + {t('expense')}
      </AddExpenseButton>
      {cardDetails && (
        <ScaleFade className='w-100'>
          <CardDetails
            className='card-details'
            cardDetails={cardDetails}
            cardId={cardId}
            creditCardProps={{ variant: cardTypesConstants.PHYSICAL }}
            onDeleteSuccess={onDeleteCard}
            onPauseSuccess={handlePauseSuccess}
          />
        </ScaleFade>
      )}
    </StyledUserOverviewRightPanel>
  );
}

UserOverviewRightPanel.propTypes = {
  card: PropTypes.shape({
    card_id: PropTypes.string,
    owner: PropTypes.shape({
      id: PropTypes.string,
    })
  }),
  handleUpdateCard: PropTypes.func,
}

export default UserOverviewRightPanel;
